import LoadingIndicator from './loading_indicator';
import Event from '../../utils/event';
import DOM from '../../utils/dom';
import {SYSTEM_EVENTS} from '../../events/events';
import {ON_DEMAND} from "../../services/hybrid/native/native_const";
import _ from '../../utils/underscore';


export default class LoadingIndicatorEmbedded extends LoadingIndicator {
    static CLASS = 'LoadingIndicatorEmbedded';

    _toasterIndicatorTimeoutInSeconds = 15;
    _minPercentForIndicatorToater = 10;
    _progressWrap = null;
    _progressPercent = null;
    _circleBg = null;
    _circlebginner = null;
    _circlebgouter = null;
    _canvas = null;
    _closeButton = null;
    _nLineWidth = 6;
    _percent = 0;
    _numberOfPackagesElem= null;
    _toasterIndicatorTimeout = null;
    _packageNumber = 1;

    showLoadingIndicator() {
        this.onSystemEvent([SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_UPDATE, SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_UPDATE_V2], this._onUpdateProgressBar);
        super.showLoadingIndicator();
        this._startToasterIndicatorTimeout();
        const analyticsData = {
            category: ON_DEMAND.ON_DEMAND_CATEGORY,
            action: "show_hybrid_loader"
        };

        this._sendAnalytics(analyticsData);
    }

    _showToaster(){
        this.serviceFactory.toasterService().showToasterNotification({
            MessageID: 'loading_indication_message',
            Type: 'timed_toaster',
            Title: this.serviceFactory.languageService().translation('hybrid_embedded_slow_connection_toaster_title'),
            SubTitle: this.serviceFactory.languageService().translation('hybrid_embedded_slow_connection_toaster_text'),
            DurationInSec: 10
        });

        const analyticsData = {
            category: ON_DEMAND.ON_DEMAND_CATEGORY,
            action: "slow_internet_toaster",
            label: this._toasterIndicatorTimeoutInSeconds,
            value: this._percent
        };

        this._sendAnalytics(analyticsData);
    }

    _startToasterIndicatorTimeout() {
        this._toasterIndicatorTimeout = this.setTimeout(()=> {
            if(this._percent < this._minPercentForIndicatorToater) {
                this._showToaster();
            }
        }, this._toasterIndicatorTimeoutInSeconds * 1000);
    }

    _paintCircle() {
        this._circleBg = this.createClassWithId('circle-bg', '<div>', true);
        this._circlebginner = this.createClassWithId('circle-bg-inner', '<div>', true);
        this._circlebgouter = this.createClassWithId('circle-bg-outer', '<div>', true);
        this._canvas = this.createClassWithId('progress-canvas', '<canvas>', true);
        this._canvas.width = 125;
        this._canvas.height = this._canvas.width;
        this._center = this._canvas.width / 2;
        this._radius = (this._canvas.width - this._nLineWidth) / 2;
    }

    _showPackageStatus() {
        this._numberOfPackagesElem = this.createClassWithId('packages-status', '<div>', false);
        DOM.append(this._loader, this._numberOfPackagesElem);
    }

    _clearPreviousChildrenElements() {
        if(this._progressWrap) {
            DOM.removeElement(this._loader, this._progressWrap);
            this._progressWrap = null;
        }
        if(this._numberOfPackagesElem) {
            DOM.removeElement(this._loader, this._numberOfPackagesElem);
            this._numberOfPackagesElem = null;
        }
    }

    addChildrenElements() {
        this._clearPreviousChildrenElements();

        if(this._percent === 0 && this._packageNumber === 1) {
            this._progressWrap = this.createClassWithId('loading-animation-container', '<div>', false);
            this.createClassWithId('loading-animation-text', '<div>', true, this.serviceFactory.languageService().translation('hybrid_embedded_loading_game'));
            this.createClassWithId('loading-animation', '<div>', true);
        } else {
            this._showPackageStatus();
            this._progressWrap = this.createClassWithId('progress-wrap', '<div>', false);
            this._progressPercent = this.createClassWithId('progress-percent', '<span>', true);
            DOM.addClass(this._progressPercent,'cgp-theme-property-color-main');
            this._paintCircle();
        }

        this._closeButton = this.createClassWithId('button-progress', '<button>', false);
        this._closeButton.className = 'button-progress game-panel-close-btn cgp-themes-icons-x cgp-theme-property-background-color-darkmain';
        DOM.append(this._loaderWrapper, this._closeButton);

        this._closeButton.addEventListener('click', function() {
            Event.fire(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_CLOSED_BY_X);
        });

        DOM.append(this._loader, this._progressWrap);
    }

    createClassWithId(name, type, append, text = '') {
        let el = DOM.$$(type);
        DOM.addClass(el, name);
        el.id = name;
        if(text) {
            el.innerText = text;
        }
        if (append) {
            DOM.append(this._progressWrap, el);
        }

        return el;
    }

    _convertParamsToV2(data) {
        if(_.isObject(data)) {
            return data;
        } else {
            return {
                statusBar: data ,
                numberOfPackages: '1/1'
            }
        }
    }

    _updateNumberOfPackages(data) {
        try {
            const totalNumberOfPackages = Number(data.numberOfPackages.split('/')[1]);
            this._numberOfPackagesElem.innerHTML = totalNumberOfPackages > 1 ? this.serviceFactory.languageService().translation('hybrid_embedded_loading_game_packages_status', {packagesStatus: data.numberOfPackages}) : '';
        } catch(err) {
            this.logger.error('_updateNumberOfPackages execute failed', err);
        }
    }

    _onUpdateProgressBar(data) {
        this.logger.debug('_onUpdateProgressBar data: ', data);

        data = this._convertParamsToV2(data);
        this._percent = Number(data.statusBar);
        this._packageNumber = Number(data?.numberOfPackages?.split('/')[0]);

        if(this._toasterIndicatorTimeout && this._percent > this._minPercentForIndicatorToater) {
            clearTimeout(this._toasterIndicatorTimeout);
            this._toasterIndicatorTimeout = null;
        }

        this.addChildrenElements();
        this._updateNumberOfPackages(data);
        if(this._canvas) {
            let context = this._canvas.getContext('2d');
            let per = this._getPercent(this._percent);
            this._progressPercent.innerHTML = this._percent + '%';

            context.beginPath();
            context.arc(this._center, this._center, this._radius, 0, per, false);
            context.lineWidth = this._nLineWidth;
            context.lineCap = 'round';
            context.strokeStyle = getComputedStyle(this._canvas).getPropertyValue('color');
            context.imageSmoothingEnabled = false;
            context.stroke();
        }
    }

    _getPercent(counter) {
        counter = Number(counter);
        counter = Math.min(100, counter);
        counter = Math.max(0, counter);
        return 2 * Math.PI * counter / 100;
    }
}